<div class="login-wrapper">
    <!-- Left Side - Branding Section -->
    <div class="login-brand-section">
        <div class="brand-content">
            <div class="brand-logo">
                💼
            </div>
            <h2>Welcome to JanarGroup</h2>
            <p>Your gateway to amazing career opportunities. Join thousands of candidates finding their dream jobs.</p>

            <div class="brand-features">
                <div class="feature-item">
                    <div class="feature-icon">🚀</div>
                    <div class="feature-text">Quick and easy application process</div>
                </div>
                <div class="feature-item">
                    <div class="feature-icon">📊</div>
                    <div class="feature-text">Track your application status in real-time</div>
                </div>
            </div>
        </div>
    </div>

    <!-- Right Side - Login Form Section -->
    <div class="login-form-section">
        <div class="login-form-container">
            <div class="form-header">
                <h1>Sign In</h1>
                <p>Enter your credentials to access your account</p>
            </div>

            <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
                <!-- User Name Field -->
                <div class="form-group">
                    <label class="form-label" for="UserName">User Name</label>
                    <div class="input-wrapper">
                        <span class="input-icon">
                            <i class="ki-duotone ki-user fs-2 text-primary">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </span>
                        <input type="email" id="UserName" formControlName="userName" class="form-input"
                            placeholder="Enter your Email"
                            [class.is-invalid]="userName?.invalid && (userName?.dirty || userName?.touched)" />
                    </div>
                    <div class="input-error" *ngIf="userName?.invalid && (userName?.dirty || userName?.touched)">
                        <span *ngIf="userName?.errors?.['required']">⚠️ Username is required</span>
                    </div>
                </div>
            
                <!-- Password Field -->
                <div class="form-group">
                    <label class="form-label" for="password">Password</label>
                    <div class="input-wrapper">
                        <span class="input-icon">
                            <i class="ki-duotone ki-lock-3 fs-2 text-primary">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                            </i>
                        </span>
                        <input type="password" id="password" formControlName="password" class="form-input"
                            placeholder="Enter your password"
                            [class.is-invalid]="password?.invalid && (password?.dirty || password?.touched)" />
                    </div>
                    <div class="input-error" *ngIf="password?.invalid && (password?.dirty || password?.touched)">
                        <span *ngIf="password?.errors?.['required']">⚠️ Password is required</span>
                        <span *ngIf="password?.errors?.['minlength']">⚠️ Password must be at least 6 characters</span>
                    </div>
                </div>
            
                <!-- Submit Button -->
                <button type="submit" class="submit-button" [disabled]="loginForm.invalid">Sign In</button>
            </form>
        </div>
    </div>
</div>